import { ApiItemType } from '@highimpact-frontend/api-types';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import TabComponent, {
  MUITabItemSettings as TabSettings,
} from '../../../../components/utils/MUISpecifics/tabs/TabComponent';
import { usePermission } from '../../../../components/utils/permission/helpers/usePermission';

type DevicesTabsProps = {
  manualSensor: React.ReactNode; //ApiReturnManualSensor;
  automaticSensor: React.ReactNode; //ApiReturnAutomaticSensor;
  project_id?: number;
  site_id?: number;
  company_id?: number;
};

const DevicesTabs = ({
  manualSensor,
  automaticSensor,
  project_id,
  site_id,
  company_id,
}: DevicesTabsProps) => {
  const { t } = useTranslation('menu');
  /** Obtain permissions for each tab */
  const manualPerm = usePermission(
    'configuration_manual_device_tab',
    project_id,
    site_id,
    company_id
  );

  const automaticPerm = usePermission(
    'configuration_automatic_device_tab',
    project_id,
    site_id,
    company_id
  );

  /**
   * Building the final tab array
   * * hidden tabs are NOT included in the array
   * * disable → tab.disabled = true
   * * messages can be embedded inside children if necessary
   */
  const filteredTabs: TabSettings[] = useMemo(() => {
    const result: TabSettings[] = [];

    if (manualPerm.shouldRender) {
      result.push({
        label: t('Dispositifs de mesure'),
        itemName: 'configuration_manual_device_tab' as ApiItemType,
        children: manualPerm.message ? (
          <div>{manualPerm.message}</div>
        ) : (
          manualSensor
        ),
        action: manualPerm.action,
      });
    }

    if (automaticPerm.shouldRender) {
      result.push({
        label: t('Capteurs connectés'),
        itemName: 'configuration_automatic_device_tab' as ApiItemType,
        children: automaticPerm.message ? (
          <div>{automaticPerm.message}</div>
        ) : (
          automaticSensor
        ),
        action: automaticPerm.action,
      });
    }

    return result;
  }, [manualPerm, automaticPerm, manualSensor, automaticSensor]);

  return <TabComponent tabs={filteredTabs} storageKey="devices-tab" />;
};

export default DevicesTabs;
